import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {environment} from "../../environments/environment";
import {ROUTES_PATHS} from "../const/routes";
import {menuItemsHeader} from "../const/menu-items-header";
import {denyAccessToMyInformation} from "../const/utils";

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
	pageName: any = location.pathname.split('/')[1];
	menuItems: any[] = [];
	imageUrl = "/assets/images/logo_KT.svg";
	widthLogo = "130";
	boShowed = false;
	usePermissions = false;
	token = JSON.parse(localStorage.getItem("token")!);

	constructor(
		public app: AppComponent,
	) {
	}

	ngOnInit(): void {
		this.app.sharedToolsService.getParamSettings('logo_header').subscribe((url: string) => {
			this.imageUrl = url;
		});

		this.app.sharedToolsService.getParamSettings('use_permissions').subscribe((isUsed: boolean) => {
			this.usePermissions = isUsed;
		});

		this.app.sharedToolsService.getParamSettings('width_logo').subscribe((width_logo: string) => {
			if (width_logo) this.widthLogo = width_logo;
		});

		this.app.sharedToolsService.getParamSettings('bo_showed').subscribe((is_showed: boolean) => {
			this.boShowed = is_showed;

			if(this.usePermissions){
				let permissions = this.token.permissions ?? [];
				this.menuItems = menuItemsHeader.filter((item: any) =>
					item.environment?.includes(environment.name) && permissions.includes(item.permission)
				);
			} else {
				this.menuItems = menuItemsHeader.filter((item: any) =>
					item.environment?.includes(environment.name)
					&& !(item.path === ROUTES_PATHS.MON_COMPTE && !this.boShowed)
				);
			}
			this.menuItems = this.menuItems.map((item: any) => {
				this.changeLabelMyAccount(item);
				return item;
			});

			if (this.pageName == ROUTES_PATHS.INSCRIPTION || this.pageName == ROUTES_PATHS.CONTACT_EXTERNE) this.menuItems = [];
		});
	}

	private changeLabelMyAccount(item:any){
		const refKey = this.app.sharedToolsService.returnObjectSwitchRefId();
		if (denyAccessToMyInformation.includes(refKey)) {
			if (item.path === ROUTES_PATHS.MON_COMPTE) {
				item.label = 'Mes estimations';
			}
			return item;
		}
	}

	isNotBackOffice() {
		//console.log(this.pageName);
		return this.pageName !== ROUTES_PATHS.MON_COMPTE && this.pageName !== ROUTES_PATHS.AGENCES && this.pageName !== ROUTES_PATHS.AGENTS && this.pageName !== ROUTES_PATHS.ESTIMATIONS
			&& this.pageName !== ROUTES_PATHS.CLIENTS && this.pageName !== ROUTES_PATHS.TUTORIELS && this.pageName !== ROUTES_PATHS.INSCRIPTION;
	}
}
